<script>
import List from "./List.vue";
import FilteredList from "./FilteredList.vue";
import Form from "./Form.vue";
import RegularHoursFilteredList from "./partials/RegularHoursFilteredList.vue";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    listItems: {
      required: true,
      default: () => {
        return {};
      },
    },
    selectedItem: {
      type: Object,
      required: true,
    },
    prevSelectedItem: {
      type: String,
      required: true,
    },
    setSelectedItems: {
      type: Function,
      required: false,
    },
    updateSelectedItem: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
  },
  components: {
    List,
    Form,
    FilteredList,
    RegularHoursFilteredList,
  },
};
</script>
<template>
  <div>
    <RegularHoursFilteredList
      v-if="item.list.variant == 'regularHoursFilteredList'"
      :style="item.list.style"
      :class="`col-${item.list.size} ${item.list.class}`"
      :item="item.list"
      :listData="listItems"
      :items="item.list.children"
      :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems"
      :listItems="listItems"
      :prevSelectedItem="prevSelectedItem"
      :topbarControls="topbarControls"
    />
    <FilteredList
      v-else-if="item.list.variant == 'filtered'"
      :style="item.list.style"
      :class="`col-${item.list.size} ${item.list.class}`"
      :item="item.list"
      :listData="listItems"
      :items="item.list.children"
      :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems"
      :listItems="listItems"
      :prevSelectedItem="prevSelectedItem"
      :topbarControls="topbarControls"
    />
    <List
      v-else
      :style="item.list.style"
      :class="`col-${item.list.size} ${item.list.class}`"
      :item="item.list"
      :listData="listItems"
      :items="item.list.children"
      :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems"
      :listItems="listItems"
      :prevSelectedItem="prevSelectedItem"
      :topbarControls="topbarControls"
    />
    <Form
      v-if="!loading"
      :style="item.form.style"
      :class="`col-${item.form.size} ${item.form.class}`"
      :form="item.form.form"
      :variant="item.form.variant"
      :data="selectedItem"
      :topbarControls="topbarControls"
      :selectedItem="selectedItem"
      :setSelectedItems="setSelectedItems"
      :updateSelectedItem="updateSelectedItem"
      :rules="item.form.rules"
    />
  </div>
</template>

<style scoped>
.simplebar-custom {
  max-height: calc(100vh - 300px);
  padding-right: 2em;
}
</style>
